import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';
import { PageLoader } from '@/widgets/page';

export const AlarmManagementPage = withSuspense(
	lazy(async () => await import('./alarm-management-page.component')),
	PageLoader,
);
